document.addEventListener("DOMContentLoaded", function () {
	const wrapper = document.querySelector(".presse-carrousel");
	if (!wrapper) return;

	function checkOverflow() {
		wrapper.classList.toggle(
			"iscarrousel",
			wrapper.scrollWidth > wrapper.clientWidth,
		);
	}

	checkOverflow();
	window.addEventListener("resize", checkOverflow);
});
